import React from 'react';
import { useNavigate } from 'react-router-dom';
import PanchTatvaButton from '../components/PanchTatvaButton';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-4xl mx-auto px-4 md:px-6 py-12 md:py-20">
      {/* 404 Section */}
      <div className="text-center mb-12">
        <h1 className="text-6xl md:text-8xl font-bold text-secondary mb-4">404</h1>
        <h2 className="text-3xl md:text-4xl font-heading text-headingText mb-4">Page Not Found</h2>
        <p className="text-lg text-bodyText mb-8">
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>

        {/* Search Box */}
        <div className="max-w-md mx-auto mb-12">
          <div className="flex gap-2">
            <input
              type="text"
              placeholder="Search for products..."
              className="flex-1 px-4 py-3 rounded-lg border-2 border-gray-300 bg-primaryBg text-bodyText focus:outline-none focus:border-secondary"
            />
            <button className="px-6 py-3 rounded-lg bg-secondary text-primaryBg font-semibold hover:opacity-90 transition">
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Quick Navigation */}
      <div className="mb-12">
        <h3 className="text-xl font-heading text-headingText text-center mb-6">Quick Navigation</h3>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <button
            onClick={() => navigate('/')}
            className="p-4 bg-cardBg rounded-lg shadow-lg hover:shadow-xl transition text-center"
          >
            <p className="text-2xl mb-2">🏠</p>
            <p className="font-semibold text-bodyText">Home</p>
          </button>

          <button
            onClick={() => navigate('/shop')}
            className="p-4 bg-cardBg rounded-lg shadow-lg hover:shadow-xl transition text-center"
          >
            <p className="text-2xl mb-2">🛍️</p>
            <p className="font-semibold text-bodyText">Shop</p>
          </button>

          <button
            onClick={() => navigate('/about')}
            className="p-4 bg-cardBg rounded-lg shadow-lg hover:shadow-xl transition text-center"
          >
            <p className="text-2xl mb-2">ℹ️</p>
            <p className="font-semibold text-bodyText">About</p>
          </button>

          <button
            onClick={() => navigate('/cart')}
            className="p-4 bg-cardBg rounded-lg shadow-lg hover:shadow-xl transition text-center"
          >
            <p className="text-2xl mb-2">🛒</p>
            <p className="font-semibold text-bodyText">Cart</p>
          </button>
        </div>
      </div>

      {/* Popular Products */}
      <div className="mb-12">
        <h3 className="text-xl font-heading text-headingText text-center mb-6">Popular Products</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { name: 'Earth Soap', emoji: '🌍' },
            { name: 'Water Soap', emoji: '💧' },
            { name: 'Fire Soap', emoji: '🔥' },
          ].map((product, index) => (
            <button
              key={index}
              onClick={() => navigate('/shop')}
              className="p-6 bg-cardBg rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition text-center"
            >
              <p className="text-4xl mb-3">{product.emoji}</p>
              <p className="font-semibold text-bodyText">{product.name}</p>
              <p className="text-sm text-gray-600 mt-2">Browse Collection</p>
            </button>
          ))}
        </div>
      </div>

      {/* Sitemap Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
        <div>
          <h4 className="font-semibold text-headingText mb-3">Shop</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <button
                onClick={() => navigate('/shop')}
                className="text-secondary hover:underline"
              >
                All Products
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate('/')}
                className="text-secondary hover:underline"
              >
                Explore Elements
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-headingText mb-3">Company</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <button
                onClick={() => navigate('/about')}
                className="text-secondary hover:underline"
              >
                About Us
              </button>
            </li>
            <li>
              <a href="/" className="text-secondary hover:underline">
                Contact
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-headingText mb-3">Help</h4>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="/" className="text-secondary hover:underline">
                FAQ
              </a>
            </li>
            <li>
              <a href="/" className="text-secondary hover:underline">
                Shipping Info
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* CTA Buttons */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <PanchTatvaButton onClick={() => navigate('/')}>
          Back to Home
        </PanchTatvaButton>
        <PanchTatvaButton variant="secondary" onClick={() => navigate('/shop')}>
          Continue Shopping
        </PanchTatvaButton>
      </div>

      {/* Support Info */}
      <div className="mt-12 text-center p-6 bg-cardBg rounded-lg">
        <p className="text-bodyText mb-2">
          Still having trouble finding what you need?
        </p>
        <p className="text-sm text-gray-600">
          📧{' '}
          <a href="mailto:support@panch-tatva.com" className="text-secondary hover:underline">
            Contact our support team
          </a>
        </p>
      </div>
    </div>
  );
}
